export default {
    colors:
        '[{"id":0,"color":"#1C1C1C","title":"DEFAULT TEXT"},{"id":1,"color":"#727273","title":"GRAY TEXT"},{"id":2,"color":"#FFFFFF","title":"WHITE TEXT"},{"id":3,"color":"#20A860", "title":"NUMBER TEXT"},{"id":4,"color":"#FECC00","title":"YELLOW"},{"id":5,"color":"#A73B8F","title":"PURPLE"},{"id":6},{"id":7},{"id":8},{"id":9}]',
    primaryFont: 'Arial',
    secondaryFont: 'Georgia',
    linkDecoration: 'UNDERLINE',
    linkColor: '#0000EE',
    textStyles: {
        headerOne: {
            font: 'Helvetica',
            fontSize: '40px',
            fontWeight: '400',
            linespacing: '3',
            color: '#191339',
            styling: [],
            alignment: 'Left',
        },
        headerTwo: {
            font: 'Helvetica',
            fontSize: '30px',
            fontWeight: '400',
            linespacing: '2',
            color: '#191339',
            styling: [],
            alignment: 'Left',
        },
        headerThree: {
            font: 'Helvetica',
            fontSize: '24px',
            fontWeight: '400',
            linespacing: '1.7',
            color: '#191339',
            styling: [],
            alignment: 'Left',
        },
        headerParagraph: {
            font: 'Helvetica',
            fontSize: '16px',
            fontWeight: '400',
            linespacing: '1.5',
            color: '#2A282E',
            styling: [],
            alignment: 'Left',
        },
    },
};
